$( document ).ready(function() {

    // Page transitions
	$('.homelink, .menu-item a, .imagewrapper a').click(function() {
		$( "#intro, #content" ).fadeTo( 500 , 1, function() {
			// something
		});
	});

    // Lightbox
	var html5lightbox_options = {
        watermark: "http://html5box.com/images/html5boxlogo.png",
        watermarklink: ""
    };

    // CF7 lookbook redirect
    document.addEventListener('wpcf7mailsent', function(event) {

        if (event.detail.contactFormId == '4364') {
            location = '/lookbook/bedankt';
        }

    }, false );

});
